/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_2_StateInputs */

const en_cap_money_mock_2_state = /** @type {(inputs: Cap_Money_Mock_2_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Researching`)
};

const lv_cap_money_mock_2_state = /** @type {(inputs: Cap_Money_Mock_2_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izpēte`)
};

/**
* | output |
* | --- |
* | "Researching" |
*
* @param {Cap_Money_Mock_2_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_2_state = /** @type {((inputs?: Cap_Money_Mock_2_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_2_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_2_state(inputs)
	return en_cap_money_mock_2_state(inputs)
});